import { Injectable } from '@angular/core';

const USER_TOKEN = 'auth-token';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() {}

  clean(): void {
    window.sessionStorage.clear();
  }

  public saveUserToken(token: string): void {
    window.sessionStorage.removeItem(USER_TOKEN);
    window.sessionStorage.setItem(USER_TOKEN, JSON.stringify(token));
  }

  public getUserToken(): any {
    const token = window.sessionStorage.getItem(USER_TOKEN);

    if (token) {
      return token;
    }

    return undefined;
  }
}
